export default [
  {
    check: true,
    title: "일반작업",
    data: [
      { content: "• 작업구역 설정(출입경고 표지)", isChecked: "" },
      { content: "• 가스농도 측정", isChecked: "" },
      { content: "• 밸브차단 및 차단표지 부착", isChecked: "" },
      { content: "• 맹판설치 및 표지부착", isChecked: "" },
      { content: "• 용기개방 및 압력방출", isChecked: "" },
      { content: "• 위험물질방출 및 처리", isChecked: "" },
      { content: "• 용기내부 세정 및 처리", isChecked: "" },
      { content: "• 불활성가스 치환 및 환기", isChecked: "" },
      { content: "• 정전/잠금/표지부착", isChecked: "" },
      { content: "• 환기장비", isChecked: "" },
      { content: "• 조명장비", isChecked: "" },
      { content: "• 소 화 기", isChecked: "" },
      { content: "• 안전장구", isChecked: "" },
      { content: "• 안전교육", isChecked: "" },
      { content: "• 운전요원의 입회", isChecked: "" },
    ],
  },
  {
    check: false,
    title: "전기차단(정전)작업",
    data: [
      { title: "제어반", content: "• 주 차단 스위치 내림", isChecked: "" },
      { title: "제어반", content: "• 제어차단기 내림", isChecked: "" },
      { title: "제어반", content: "• 잠금장치", isChecked: "" },
      { title: "제어반", content: "• 시험전원 차단", isChecked: "" },
      { title: "제어반", content: "• 차단표지판 부착", isChecked: "" },
      { title: "현장기기", content: "• 현장스위치 내림", isChecked: "" },
      { title: "현장기기", content: "• 차단표지판 부착", isChecked: "" },
    ],
  },
  {
    check: false,
    title: "고소 작업",
    data: [
      { content: "1. 작업에 적합한 작업발판 및 안전난간 설치 여부", isChecked: "" },
      { content: "2. 안전대 착용 및 부착 여부기 내림", isChecked: "" },
      { content: "3. 추락 방지용 방망 설치 여부", isChecked: "" },
    ],
  },
];
